import { Container, Typography, Box } from '@mui/material'

export default function PaymentMethodsPage() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom>
          Payment Methods
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          This page will display available payment methods including Easypaisa, JazzCash, and Bank Transfer.
        </Typography>
      </Box>
    </Container>
  )
}